<template>
  <div class="indeCenH">
    <div><img src="../assets/img/he-top.png" alt="合作伙伴"></div>
    <h2><span></span>合作伙伴<span></span></h2>
    <img src="../assets/img/he-cen.png" alt="合作伙伴">
    <p class="beianPtips"><span @click="goBeian">陕ICP备15007224号  出版物网络交易平台服务经营备案号：新出发批兼零字第023号</span></p>
  </div>
</template>

<script>
  export default {
  	name: 'indexCenterH',
  	data () {
  		return {

  		}
  	},
    mounted:function(){

    },
  	methods:{
      goBeian(){
        window.location.href = 'http://www.beian.miit.gov.cn';
      },
  	}
  }
</script>

<style scoped lang="scss">
  .indeCenH{
    padding-bottom: 3rem;
    .beianPtips{
      position: absolute;
      left: 0;
      bottom: 2rem;
      width: 100%;
      color: #3a3a3a;
      text-align: center;
      span:hover{
        color: #000;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    div{
      background: url(../assets/img/he-bg.png) no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 22rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 34rem;
        margin: 0;
      }
    }
    h2{
      margin: 3.5rem 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.6rem;
      font-weight: 100;
      span{
        margin: 0 1.5rem;
        width: 8rem;
        height: 1px;
        background: #000;
      }
    }
    img{
      width: 70%;
      margin: 4rem auto 0;
    }
    @media screen and (max-width: 1400px) {
      div{
        img{
          width: 50%;
        }
      }
      img{
        width: 100%;
      }
    }
    @media screen and (max-width: 600px) {
      div{
        height: 15rem;
      }
      h2{
        font-size: 1rem;
        margin: 2rem 0;
        span{
          margin: 0 1rem;
          width: 6rem;
        }
      }
      img{
        margin: 2rem auto 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexCenterH.vue